import packageInfo from '../../package.json';

export const environment = {
    name: 'staging',
    production: false,
    backendUrl: 'https://api-staging.mercatus.one',
    apiUrl: 'https://api-staging.mercatus.one/api/v1.0',
    VERSION: packageInfo.version,
    maintenanceMode: false,
    auth0: {
        domain: "login-staging.mercatus.one",
        clientId: "NnwhE7DGxscX9GP1WVK8PYRe54JcB8V3",
        audience: "https://api.mercatus.one"
    }
};
